import { render } from "./ButtonTransparent.vue?vue&type=template&id=11fe5c74"
import script from "./ButtonTransparent.vue?vue&type=script&lang=js"
export * from "./ButtonTransparent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Host\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__